import * as $ from "jquery";
import {IAttributes, IAugmentedJQuery, IDirective, IDirectiveFactory, ILogService, IScope, ITimeoutService} from "angular";

export class AccessibleForm implements IDirective {
    public link: (scope: IScope, element: IAugmentedJQuery, attrs: IAttributes) => void;
    public restrict = "A";
    public scope = true;
    public  OFFSET = 100;
    /* @ngInject */
    public static factory(): IDirectiveFactory {
        const directive: IDirectiveFactory = ($timeout: ITimeoutService, $log: ILogService) => new AccessibleForm($timeout, $log);
        directive.$inject = ["$timeout", "$log"];
        return directive;
    }

    /* @ngInject */
    constructor(private $timeout: ITimeoutService, private $log: ILogService) {

        AccessibleForm.prototype.link = (scope: IScope, elem: IAugmentedJQuery, attrs: IAttributes) => {
            elem.bind("submit", (event: JQueryEventObject) => {
                // find the first invalid element

                const scrollElement: HTMLElement = elem[0].querySelector("input.ng-invalid,select.ng-invalid,textarea.invalid,.links-invalid") as HTMLElement;
                const bodyElement: HTMLElement = document.querySelector("body") as HTMLElement;



                // set focus and scroll to position
                if (scrollElement) {
                    this.smoothScroll(scrollElement);

                    const validElements: string[] = ["INPUT", "SELECT", "TEXTAREA"];
                    if (validElements.indexOf(scrollElement.tagName) >= 0) {
                        // this.$log.debug(scrollElement);
                        scrollElement.focus();
                    } else {
                        const focusElement = scrollElement.querySelector("input, select, textarea") as HTMLElement;
                        this.$log.debug(focusElement);
                        if (focusElement) {
                            focusElement.focus();
                        }
                    }
                }
            });
        };
    }


    private currentYPosition() {
        // Firefox, Chrome, Opera, Safari
        if (self.pageYOffset) {
            return self.pageYOffset;
        }
        // Internet Explorer 6 - standards mode
        if (document.documentElement && document.documentElement.scrollTop) {
            return document.documentElement.scrollTop;
        }

        // Internet Explorer 6, 7 and 8
        if (document.body.scrollTop) {
            return document.body.scrollTop;
        }
        return 0;
    }

    private elmYPosition(elm: HTMLElement) {
        //let elm = document.getElementById(eID);
        let y = elm.offsetTop;
        let node = elm;
        while (node.offsetParent && node.offsetParent !== document.body) {
            node = node.offsetParent as HTMLElement;
            y += node.offsetTop;
        }
        return y;
    }

    private smoothScroll(elm: HTMLElement) {
        const startY = this.currentYPosition();
        const stopY = this.elmYPosition(elm) - this.OFFSET;
        const distance = stopY > startY ? stopY - startY : startY - stopY;
        if (distance < 100) {
            scrollTo(0, stopY);
            return;
        }
        let speed = Math.round(distance / 100);
        if (speed >= 20) {
            speed = 20;
        }
        const step = Math.round(distance / 25);
        let leapY = stopY > startY ? startY + step : startY - step;
        let timer = 0;

        if (stopY > startY) {
            for (let i = startY; i < stopY; i += step) {
                setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
                leapY += step;
                if (leapY > stopY) {
                    leapY = stopY;
                }
                timer++;
            }
            return;
        }
        for (let i = startY; i > stopY; i -= step) {
            setTimeout("window.scrollTo(0, " + leapY + ")", timer * speed);
            leapY -= step;
            if (leapY < stopY) {
                leapY = stopY;
            }
            timer++;
        }
        return false;
    }
}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/widget/accessible-form.directive.ts